import http from '../utils/http';

const moduleApi = {
    /**
     * 权限-菜单-获取菜单树状结构
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#133
     * @returns Promise
     */
    listAllModule(options = {}, config = {}) {
        return http.post('/module/listAllModule', options, {
            ...config
        })
    },

    // 权限-菜单-获取登录用户的菜单
    listUserModule(options = {}, config = {}) {
        return http.post('/module/listUserModule', options, {
            ...config
        })
    },

    /**
     * 权限-获取角色用户的菜单
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#133
     * @returns Promise
     */
    listRoleModule(options = {}, config = {}) {
        return http.post('/module/listRoleModule', options, {
            ...config
        })
    },


    /**
     * 权限-菜单新增
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#133
     * @returns Promise
     */
    save(options = {}, config = {}) {
        return http.post('/module/save', options, {
            ...config
        })
    },

    /**
     * 权限-菜单修改
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#133
     * @returns Promise
     */
    update(options = {}, config = {}) {
        return http.post('/module/update', options, {
            ...config
        })
    },

    /**
     * 权限-菜单删除
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#133
     * @returns Promise
     */
    delete(options = {}, config = {}) {
        return http.post('/module/delete', options, {
            ...config
        })
    },
}

export default moduleApi;
